const RESOURCES_IT = {
  AIPR: "AIPR",
  BTP_PRO_CARD: "Tessera Professionale BTP",
  CACES: "CACES",
  CE_CERTIFICATE: "Certificato CE",
  CE_CERTIFICATION: "Certificazione CE",
  DELIVERY: "Consegna",
  DEPARTURE_NOTE: "Nota di partenza",
  DRIVING_AUTHORIZATION: "Autorizzazione alla Guida",
  DUE: "Dovuto",
  documentsStatus: "Stato dei documenti",
  EMAILS: "Email",
  HOUR_SHEET: "Fogli ore",
  ICON: "Icona",
  ID: "ID",
  IDENTITY: "Identità",
  INSURANCE: "Assicurazione",
  INVOICE: "Fattura",
  KBIS: "Kbis",
  LIFTING_PLAN: "Piano di Sollevamento",
  LIFTING_SHEET: "Scheda di Sollevamento",
  LOGO: "Logo",
  MACHINE_SPECIFICATIONS: "Specifiche della Macchina",
  MAINTENANCE_LOG: "Registro di Manutenzione",
  MAINTENANCE_LOG_EXCERPT: "Estratto del Registro di Manutenzione",
  MEDICAL_CERTIFICATE: "Certificato Medico",
  OPERATOR_DOCUMENT: "Documento dell'Operatore",
  OTHER: "Altro",
  PGI: "PGI",
  PHOTO: "Foto",
  PIC: "PIC",
  PURCHASE_ORDER: "Ordine di Acquisto",
  QUOTATION: "Preventivo",
  RETURN_NOTE: "Nota di reso",
  RIB: "RIB",
  SIGNED_RENTAL_REQUEST: "Richiesta di Noleggio Firmata",
  SPECIFIC_TRAINING: "Formazione Specifica",
  TECHNICAL_SHEET: "Scheda Tecnica",
  USED_MACHINE_CERTIFICATE: "Certificato Macchina Usata",
  USER_MANUAL: "Manuale Utente",
  VGP: "VGP",
  WORK_ORDER: "Ordine di lavoro",
} as const;

export default RESOURCES_IT;
